import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRoute } from "vue-router";
import TileCard from "@/components/util/TileCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationSettingsView',
  setup(__props) {

const router = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", null, [
      _createVNode(_component_router_link, {
        to: { name: 'AppSettings' },
        class: _normalizeClass({ active: _unref(router).name == 'AppSettings' })
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Application settings", -1)
        ]))]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: { name: 'PublicHolidays' },
        class: _normalizeClass({ active: _unref(router).name == 'PublicHolidays' })
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Public holidays", -1)
        ]))]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: { name: 'Services' },
        class: _normalizeClass({ active: _unref(router).name == 'Services' })
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Services", -1)
        ]))]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: { name: 'Teams' },
        class: _normalizeClass({ active: _unref(router).name == 'Teams' })
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Teams", -1)
        ]))]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: { name: 'Rates' },
        class: _normalizeClass({ active: _unref(router).name == 'Rates' })
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("Rates", -1)
        ]))]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: { name: 'Divisions' },
        class: _normalizeClass({ active: _unref(router).name == 'Divisions' })
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("Divisions", -1)
        ]))]),
        _: 1
      }, 8, ["class"])
    ]),
    _createVNode(TileCard, { class: "app-settings" }, {
      body: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })
  ], 64))
}
}

})